import { render, staticRenderFns } from "./fireworks.vue?vue&type=template&id=525ff28a&scoped=true&"
import script from "./fireworks.vue?vue&type=script&lang=js&"
export * from "./fireworks.vue?vue&type=script&lang=js&"
import style0 from "./fireworks.vue?vue&type=style&index=0&id=525ff28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ff28a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525ff28a')) {
      api.createRecord('525ff28a', component.options)
    } else {
      api.reload('525ff28a', component.options)
    }
    module.hot.accept("./fireworks.vue?vue&type=template&id=525ff28a&scoped=true&", function () {
      api.rerender('525ff28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/UserWizard/fireworks.vue"
export default component.exports